/* Browser-side translation: one English URL per page, the visitor's language applied in the browser.
 *
 * Language = the saved choice (cookie echv_lang), else the browser's language list, else the region (only when the
 * browser language is not one we offer and not English). Bots and crawlers always get plain English.
 * Translation uses the Google Translate element, driven by its `googtrans` cookie, with its own UI hidden.
 * A page still served on an older /xx/ URL is already in that language: it is left alone, and picking a language
 * there opens the English page with the choice applied.
 */
(function () {
  'use strict';

  var cfg = window.EchoviraLang || {};
  var LANGS = ['en', 'es', 'pt', 'it', 'fr', 'de', 'ru', 'tr', 'ar', 'fa', 'hi', 'ja', 'ko', 'zh-CN'];
  var RTL = ['ar', 'fa'];
  var COOKIE = 'echv_lang';
  var YEAR = 31536000;
  var COUNTRY = {
    ES: 'es', MX: 'es', AR: 'es', CO: 'es', CL: 'es', PE: 'es', VE: 'es', EC: 'es', UY: 'es',
    PT: 'pt', BR: 'pt', IT: 'it', FR: 'fr', DE: 'de', AT: 'de', RU: 'ru', TR: 'tr',
    SA: 'ar', AE: 'ar', EG: 'ar', MA: 'ar', DZ: 'ar', IQ: 'ar', IR: 'fa', IN: 'hi',
    JP: 'ja', KR: 'ko', CN: 'zh-CN'
  };
  var isBot = /bot|crawl|spider|slurp|lighthouse|headless|pagespeed|facebookexternalhit/i.test(navigator.userAgent);

  function normalize(code) {
    var base = String(code || '').toLowerCase().split('-')[0];
    if (base === 'zh') return 'zh-CN';
    return LANGS.indexOf(base) > -1 ? base : '';
  }

  function getCookie(name) {
    var m = document.cookie.match(new RegExp('(?:^|; )' + name + '=([^;]*)'));
    return m ? decodeURIComponent(m[1]) : '';
  }

  function setCookie(name, value, maxAge) {
    var base = name + '=' + encodeURIComponent(value) + '; path=/; SameSite=Lax';
    document.cookie = base + '; max-age=' + maxAge;
    // Google's cookie is read from the host and from the parent domain
    document.cookie = base + '; max-age=' + maxAge + '; domain=' + location.hostname;
  }

  function setGoogleCookie(lang) {
    if (lang === 'en') {
      setCookie('googtrans', '', 0);
    } else {
      setCookie('googtrans', '/en/' + lang, YEAR);
    }
  }

  function detect() {
    var list = navigator.languages && navigator.languages.length ? navigator.languages : [navigator.language];
    for (var i = 0; i < list.length; i++) {
      var base = String(list[i] || '').toLowerCase().split('-')[0];
      if (base === 'en') return 'en';
      var hit = normalize(list[i]);
      if (hit) return hit;
    }
    return COUNTRY[String(cfg.country || '').toUpperCase()] || 'en';
  }

  function chosen() {
    if (isBot) return 'en';
    var saved = normalize(getCookie(COOKIE));
    if (saved || getCookie(COOKIE) === 'en') return saved || 'en';
    var picked = detect();
    setCookie(COOKIE, picked, YEAR);
    return picked;
  }

  function loadTranslator(lang) {
    setGoogleCookie(lang);
    document.documentElement.dir = RTL.indexOf(lang) > -1 ? 'rtl' : 'ltr';
    var holder = document.createElement('div');
    holder.id = 'echovira_translate_el';
    holder.setAttribute('translate', 'no');
    document.body.appendChild(holder);
    window.echoviraTranslateInit = function () {
      /* global google */
      new google.translate.TranslateElement({
        pageLanguage: 'en',
        includedLanguages: LANGS.filter(function (l) { return l !== 'en'; }).join(','),
        autoDisplay: false
      }, 'echovira_translate_el');
    };
    var s = document.createElement('script');
    s.src = 'https://translate.google.com/translate_a/element.js?cb=echoviraTranslateInit';
    s.async = true;
    document.head.appendChild(s);
  }

  function onPick(event) {
    var lang = normalize(event.target.value) || 'en';
    setCookie(COOKIE, lang, YEAR);
    setGoogleCookie(lang);
    if (cfg.primary) {
      location.reload();
    } else {
      location.href = (cfg.englishPath || '/') + location.search + location.hash;
    }
  }

  function init() {
    var current = cfg.primary ? chosen() : (normalize(cfg.locale) || 'en');
    var pickers = document.querySelectorAll('[data-language-picker-select]');
    for (var i = 0; i < pickers.length; i++) {
      pickers[i].value = current;
      pickers[i].addEventListener('change', onPick);
    }
    if (cfg.primary && current !== 'en') loadTranslator(current);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
